/* tslint:disable */
/* eslint-disable */
/**
 * Selling Partner API for Orders
 * Use the Orders Selling Partner API to programmatically retrieve order information. With this API, you can develop fast, flexible, and custom applications to manage order synchronization, perform order research, and create demand-based decision support tools.   _Note:_ For the JP, AU, and SG marketplaces, the Orders API supports orders from 2016 onward. For all other marketplaces, the Orders API supports orders for the last two years (orders older than this don\'t show up in the response).
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * A field collected from the regulatory form.
 */
export interface RegulatedInformationField {
    /**
     * The unique identifier of the field.
     */
    'FieldId': string;
    /**
     * The name of the field.
     */
    'FieldLabel': string;
    /**
     * The type of field.
     */
    'FieldType': RegulatedInformationFieldFieldTypeEnum;
    /**
     * The content of the field as collected in regulatory form. Note that `FileAttachment` type fields contain a URL where you can download the attachment.
     */
    'FieldValue': string;
}

export const RegulatedInformationFieldFieldTypeEnum = {
    Text: 'Text',
    FileAttachment: 'FileAttachment',
} as const;

export type RegulatedInformationFieldFieldTypeEnum = typeof RegulatedInformationFieldFieldTypeEnum[keyof typeof RegulatedInformationFieldFieldTypeEnum];


